module.exports = "body {\n    text-align: center;\n}\n\nh3 {\n    margin-bottom: 10px;\n    text-align: center;\n}\n\n.chart_wrapper {\n    margin: 0px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/coins-owned-by-attendees/coins-owned-by-attendees.component.css
// module id = ./src/app/coins-owned-by-attendees/coins-owned-by-attendees.component.css
// module chunks = main